import ISubCategory from "../categories/ISubCategory";
import ICategory from "../categories/ICategory";
import { ITabItem } from "../../../yoello-lib/modules/components/UI/Tabs/TabList";
import { useTranslation } from "react-i18next";

const useParseTabItems = () => {
    const { t } = useTranslation();
    const parseCategoryItems = (categories: ICategory[], subcategories: ISubCategory[]) => {
        const categoryTabs = categories.map((category: ICategory) => {
            return {
                id: category.id,
                value: category.id,
                label: t(`menu.subcategories.${category?.category_name?.toUpperCase()}`),
                counter: subcategories.filter(
                    (subcat: ISubCategory) => subcat.category_id === category.id
                ).length
            }
        }).filter((tab: ITabItem) => tab.counter && tab.counter > 0);


        const defaultCategoryTab = categoryTabs[0]?.id;


        return {
            categoryTabs,
            defaultCategoryTab,
            categoriesLoaded: !!categoryTabs,

        };
    }
    const parseSubcategoryItems = (subcategories: ISubCategory[], selectedCategoryId: string) => {
        const subcategoryTabs = subcategories.filter((subcat: ISubCategory) => subcat.category_id === selectedCategoryId)
            .map((subcategory: ISubCategory) => {
                return {
                    id: subcategory.id,
                    value: subcategory.id,
                    label: subcategory.subcategory_name,
                }
            })
        const defaultSubcategoryTab = subcategoryTabs[0]?.id;
        return {
            subcategoryTabs,
            defaultSubcategoryTab,
            subcategoriesLoaded: !!subcategoryTabs,
        }
    }
    return {
        parseCategoryItems,
        parseSubcategoryItems
    }
}

export default useParseTabItems;